<template>
    <div class="page-user-statistics">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">會員管理</div>
            <div class="breadcrumb-item">會員統計</div>
        </div>

        <div class="pg-block">
            <Row>
                <Col span="10">
                <div class="statistic-info left">
                    <span>今日註冊數</span>
                    <span>{{day}}</span>
                </div>
                <div class="statistic-info left">
                    <span>本周註冊數</span>
                    <span>{{week}}</span>
                </div>
                <div class="statistic-info left">
                    <span>本月註冊數</span>
                    <span>{{month}}</span>
                </div>
                <div class="statistic-info left">
                    <span>今年註冊數</span>
                    <span>{{year}}</span>
                </div>
                </Col>

                <Col span="10" push="4">
                <div class="statistic-info">
                    <span>昨日註冊數</span>
                    <span>{{preday}}</span>
                </div>
                <div class="statistic-info">
                    <span>上周註冊數</span>
                    <span>{{preweek}}</span>
                </div>
                <div class="statistic-info">
                    <span>上月註冊數</span>
                    <span>{{premonth}}</span>
                </div>
                <div class="statistic-info">
                    <span>所有註冊數</span>
                    <span>{{all}}</span>
                </div>
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
				day: 0,
				preday: 0,
				week: 0,
				preweek: 0,
				month: 0,
				premonth: 0,
				year: 0,
				all: 0
            };
        },
        mounted()
        {
			this.getData();
        },
		methods: {
			getData() {
			    let form = this.form;
			    this.isSubmiting = true;
			    this.$Rq.requestAuth({
			        url: this.$Api.userData,
			        method: 'get',
			        data: {}
			    }).then((res) => {
			        this.isSubmiting = false;
			        if (res.code == 0) 
                    {
			            this.day = res.data.day;
						this.preday = res.data.preday;
						this.week = res.data.week;
						this.preweek = res.data.preweek;
						this.month = res.data.month;
						this.premonth = res.data.premonth;
						this.year = res.data.year;
						this.all = res.data.all;
			        } 
                    else 
                    {
			            this.showTipInfo(res.msg);
			        }
			    }).catch((err) => {
			        this.isSubmiting = false;
			    });
			},
		}
    };
</script>

<style lang="scss" scoped>
    @import "UserStatistics.scss";
</style>